import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import classNames from "classnames";

var Item = function Item(_ref) {
  var active = _ref.active,
      href = _ref.href,
      title = _ref.title,
      onItemClick = _ref.onItemClick;
  var getClassName = getClassNameFactory("PageNavItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: classNames({
        active: active
      })
    }),
    "data-active": active ? JSON.stringify(active) : null,
    "data-href": JSON.stringify(href),
    "data-title": JSON.stringify(title),
    "data-rehydratable": getRehydratableName(Item.displayName)
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "inner"
    }),
    href: href,
    onClick: onItemClick,
    "aria-current": active,
    role: "menu"
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "title"
    })
  }, title)));
};

Item.displayName = "PageNav.Item";
export default Item;